import * as React from 'react'
import { styled, css } from 'styled-components'
import { ProgressBar } from './ProgressBar'

const Container = styled.div`
  position: relative;

  display: flex;
  gap: 1rem;
  align-items: center;
`

const Button = styled.a<{ disabled: boolean }>`
  text-decoration: none;
  color: var(--bs-secondary);
  background-color: var(--bs-body-bg);
  cursor: pointer;

  transition: all 0.3s ease-in-out;

  display: flex;

  padding: 0.5em;
  border-radius: 100%;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
      padding: 0.35em;
    `}
`

interface NavigationProps {
  canNavigateNext: boolean
  canNavigatePrevious: boolean
  onNavigateNext: () => void
  onNavigatePrevious: () => void
  progressCurrent: number
  progressTotal: number
}

export const Navigation: React.FC<NavigationProps> = ({
  canNavigateNext,
  canNavigatePrevious,
  onNavigateNext,
  onNavigatePrevious,
  progressCurrent,
  progressTotal
}) => {
  return (
    <Container>
      <Button disabled={!canNavigatePrevious} onClick={onNavigatePrevious}>
        <i className="rt-arrow-left" />
      </Button>
      <ProgressBar current={progressCurrent} total={progressTotal} />
      <Button disabled={!canNavigateNext} onClick={onNavigateNext}>
        <i className="rt-arrow-right" />
      </Button>
    </Container>
  )
}
